<template>
        <div class="row justify-content-center">
            <div class="col-lg-10 col-md-10">
                <div class="card bg-secondary shadow border-0">
                    <div class="card-header bg-transparent pb-5">
                        <div class="btn-wrapper text-center">
                            <p>    </p>
                        </div>
                    </div>
                    <div class="card-body px-lg-12 py-lg-12">
                        <h3>DECLARACIÓN DE PRIVACIDAD DE DATOS</h3>

                        <p>Esta política de privacidad establece la forma en que se van a gestionar los datos personales en esta
                        web. Es imprescindible que la leas y aceptes antes de seguir navegando.
                        </p>

                        <p>
                        Gymtrao es un proyecto de Ferran Esparza con NIF 73226870-E cuya razón social está en Carrer San Agustí 5. L'Olleria - València, España.
                        </p> 

                        <p>Gymtrao es responsable de la recopilación, el procesamiento y el uso de los datos personales
                        según la legislación de protección de datos, en concreto, el Reglamento General de Protección de Datos
                        ("RGPD").
                        </p>

                        <p>
                        Tú, el cliente, según el Reglamento General de Protección de Datos ("RGPD") eres el "responsable de
                        tratamiento" de los datos personales que introduzcas en nuestra plataforma y Gymtrao, el
                        proveedor del servicio, es el "encargado de tratamiento" de datos en tu nombre. Sólo usamos tus datos en
                        cumplimiento de la legislación de protección de datos relevantes. Si tuvieras alguna consulta respecto a
                        esta política de privacidad puedes contactar con nosotros a través de nuestro correo ectrónico
                        narrefle.oficial@gmail.com.
                        </p>

                        <p>
                        Con esta Declaración de Privacidad de Datos queremos informarte qué datos personales se recopilan y se
                        guardan cuando visitas nuestro sitio web o utilizas nuestros servicios ofrecidos en el sitio web.
                        Además, recibirás información sobre cómo usamos tus datos y qué derechos tienes con respecto al uso de
                        ellos.
                        </p>

                        <h3>SEGURIDAD DE DATOS</h3>

                        <p>
                        Para protegerlos, todos los datos que nos proporcionas se cifran de acuerdo con el protocolo de
                        seguridad TLS (Transport Layer Security). El TLS es un protocolo seguro y probado que se utiliza, por
                        ejemplo, para la banca en línea. Puedes identificar la conexión TLS, por ejemplo, al observar la "s"
                        después de la "http" en la URL que se muestra en tu navegador (https://..) o desde el icono de bloqueo
                        que se muestra en la pestaña del navegador.
                        </p>

                        <p>
                        También tomamos medidas de seguridad técnicas y organizativas adecuadas para proteger tus datos contra
                        manipulaciones aleatorias o deliberadas, pérdidas parciales o totales, destrucción y/o accesos no
                        autorizados. Para evitar la pérdida de datos, almacenamos los datos periodicamente en una copia de
                        seguridad fuera del sitio. Tu contraseña se almacena a través de un proceso seguro encriptado. Nunca te
                        pediremos la contraseña, ni por correo electrónico ni por teléfono. Si olvidas tu contraseña, podemos
                        restablecerla por ti. Mejoramos nuestras medidas de seguridad continuamente en función del desarrollo
                        tecnológico.
                        </p>

                        <p>
                        Los datos personales que recopilamos se almacenan en un entorno seguro dentro de la UE y se tratan de
                        forma confidencial. El acceso a esta información está limitado al equipo de Gymtrao.
                        Cumplimos, en todo momento, con los requisitos legislativos de protección de datos.
                        </p>

                        <p>
                        Hacemos todo lo posible para proteger tus datos, pero no podemos garantizar la seguridad de tus datos
                        cuando los transfieres a través de Internet. Cuando esto ocurre, existe un cierto riesgo de que otros
                        puedan acceder a tus datos de forma ilícita. En otras palabras, al transferir datos por internet, asumes
                        la responsabilidad de la seguridad de estos como responsable del tratamiento de datos.
                        </p>

                        <h3>RECOLECCIÓN Y ALMACENAMIENTO DE DATOS PERSONALES Y NATURALEZA DE PROPÓSITO DE SU USO</h3>

                        <b>a) Si visitas nuestro sitio web</b>

                        <p>
                        Puedes visitar el sitio web Gymtrao sin revelar tu identidad. Tu navegador solo envía información
                        - que se recopila automáticamente - a los servidores de nuestro sitio web. Esta información se almacena
                        temporalmente en un archivo de registro (logfile). Esta es la información que se recopila y almacena
                        automáticamente hasta su eliminación, también automática:
                        </p>

                        <ul>
                            <li>Dirección IP del ordenador solicitante.</li>
                            <li>Fecha y hora del acceso.</li>
                            <li>Nombre y URL de los datos introducidos.</li>
                            <li>Sitio web, de donde proviene el acceso (URL de referencia).</li>
                            <li>Navegador de uso y, si es necesario, el sistema operativo de tu ordenador, así como el nombre de tu
                            proveedor de acceso.</li>
                        </ul>

                        <p>Estos datos se recopilan y procesan para hacer posible el uso de nuestro sitio web (establecimiento de
                        conexión), con el fin de garantizar la seguridad y la estabilidad de nuestro sistema, así como para la
                        administración técnica de la infraestructura de la red. Dichos datos no nos ofrecen ninguna información
                        que pueda identificarte personalmente.
                        </p>

                        <p>
                        Además, empleamos cookies, así como herramientas de análisis y de marketing web. Puedes encontrar más
                        información sobre este tema más abajo en las sección de COOKIES.
                        </p>

                        <b>b) Si te registras en nuestros servicios online</b>

                        <p>
                        En nuestro sitio web ofrecemos servicios online de registro y seguimiuento del rendimiento deportivo. Para usar estos servicios,
                        primero debes registrarte. Cuando te registras, debes introducir una dirección de correo electrónico,
                        una contraseña y tu nombre; de este modo,
                        podrás crearte una cuenta con nosotros e iniciar sesión.
                        </p>

                        <p>
                        Para emplear nuestros servicios al completo, puede que debas introducir más datos personales. Por
                        ejemplo, para poder llevar el seguimiento es posible que puedas rellenar otros datos como la altura, el
                        seguimiento del peso, de los ejercicios, rutinas, dietas, etc.
                        </p>

                        <p>También utilizamos tu nombre y tus datos de contacto con la siguiente finalidad:</p>
                        <ul>
                            <li>Para saber quién es nuestra parte contratante.</li>
                            <li>Para la justificación, estructura, procesamiento y cambio de la relación contractual contigo sobre el
                                uso de nuestros servicios.</li>
                            <li>Para verificar la plausibilidad de la información introducida.</li>
                            <li>Para contactar contigo, si es necesario.</li>

                        </ul>

                        <p>
                        Tienes el derecho a retirar, en cualquier momento, tu consentimiento para el procesamiento 
                        de tus datos, ya sea cerrando tu cuenta, que tiene efecto inmediato, o poniéndote en
                        contacto con nosotros para solicitar el cierre, para que lo hagamos tan pronto como sea posible. Una vez
                        finalizada tu relación con Gymtrao, mantenemos solamente los datos mínimos que debemos mantener
                        para cumplir con todos los requisitos legales, y solo por el período mínimo requerido.
                        </p>

                        <p>
                        Si tienes alguna pregunta sobre el procesamiento de tus datos personales, o si deseas solicitar el
                        acceso a tus datos, puedes ponerte en contacto con nosotros a través de nuestro correo elelctrónico
                        narrefle.oficial@gmail.com.
                        </p>

                        <p>
                        Si no estás satisfecho, tienes derecho a presentar una queja ante la autoridad de protección de datos
                        correspondiente. Gymtrao cooperará plenamente con cualquier investigación de este tipo y se
                        esforzará por satisfacer todas las consultas de la manera más completa posible. La autoridad pertinente
                        para cada país se puede encontrar en el sitio web de la Comisión Europea:
                        http://ec.europa.eu/newsroom/article29/item-detail.cfm?item_id=612080
                        </p>

                        <h3>COOKIES</h3>

                        <p>
                        Nuestro sitio web utiliza cookies. Las cookies son pequeños archivos que se crean automáticamente en tu
                        navegador y se almacenan en tu dispositivo (ordenador portátil, tableta, teléfono inteligente, etc.)
                        cuando visitas una página. Las cookies no dañan tu dispositivo y no contienen virus, troyanos u otro
                        software malicioso.
                        </p>

                        <p>
                        Las cookies almacenan información relacionada con tu dispositivo. Ahora bien, esto no significa que
                        recibamos ningún conocimiento detallado de tu identidad.
                        </p>

                        <p>
                        Para saber exáctamente que cookies utilizamos por favor lee nuestra Política de Cookies.
                        </p>

                        <h3>INFORMACIÓN, CORRECCIÓN, BLOQUEO, ELIMINACIÓN</h3>

                        <p>
                        Tienes derecho a la información sobre datos personales que almacenamos y el derecho a corregir o a
                        enmendar datos incorrectos, así como a bloquearlos y eliminarlos.
                        </p>

                        <p>
                        Como responsable del tratamiento de datos, eres responsable del contenido que publicas. Tienes derecho a
                        rectificar, bloquear o borrar, en cualquier momento, cualquiera de tus datos. Podemos eliminar contenido
                        que has publicado a petición tuya, pero mantenemos nuestro derecho a no eliminar el contenido que ya
                        está publicado o que debemos mantener para cumplir con determinados requisitos legales.
                        </p>

                        <p>
                        Para obtener información sobre tus datos personales, para la corrección de datos erróneos o para el
                        bloqueo o eliminación de datos, así como para otras preguntas sobre el uso de tus datos personales,
                        envía un correo electrónico a narrefle.oficial@gmail.com.
                        </p>
                        
                        <p>
                        Además, puedes ver y cambiar los datos que se almacenan en tu cuenta iniciando sesión en nuestro sitio
                        web con tus datos de acceso. Puedes eliminar los datos de tu cuenta en todo momento, sólo tienes que
                        solicitarlo por correo electrónico a narrefle.oficial@gmail.com. Advertimos que si eliminas tus datos, no
                        podrás usar nuestro servicio al completo o en absoluto.
                        </p>

                        <h3>CAMBIOS ENLA DECLARACIÓN DE PRIVACIDAD DE DATOS</h3>

                        <p>
                        Esta Declaración de Privacidad de Datos está ahora vigente y se actualizó por última vez en noviembre de
                        2020.
                        </p>

                        <p>
                        Debido al desarrollo posterior del sitio web, la aplicación Gymtrao, o cualquier otro servicio de
                        Gymtrao, o debido a cambios en los requisitos legales o reglamentarios, puede que esta
                        Declaración de Privacidad de Datos deba modificarse en un futuro. Nuestra Declaración de Privacidad de
                        Datos se puede acceder e imprimir en todo momento en nuestro sitio web;
                        <a href="/politica_privacidad">Politica de privacidad</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
</template>
<script>
  export default {

    name: 'Política de privacidad',
    data() {
      return {
          email: '',
          password: ''
        
      }
    }
  }
</script>
<style>
</style>